import React, { useState } from "react";
import { ListTable } from "../Table/listTable/listTable";
import { Card } from "../card";
import { useParentsList } from "../../hooks/parentsHooks/useParentsList.hooks";
import { useNavigate } from "react-router-dom";
import { transformParentsListTableData } from "../../Services/transformer/transformParentsListTableData";
import { Paths } from "../../Constants/paths";
import { ParentNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { parentsListTitle } from "../../Constants/tableTitles/ListTableTitle/parentsList.titles";
import { FilterBar, FilterInput } from "../FilterBar";

export const ParentsList = () => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [userNameToSearch, setUserNameToSearch] = useState<string>("");
  const [userIdToSearch, setUserIdToSearch] = useState<string>("");

  const [pageToSearch, setPageToSearch] = useState(1);

  const { isLoading, data } = useParentsList({
    page: pageToSearch,
    userNameToSearch,
    userIdToSearch,
  });

  const handleSearch = () => {
    setPageToSearch(
      1,
    ); /*  This is necessary as it calls the api multiple time */
    setUserIdToSearch(userId);
    setUserNameToSearch(userName);
  };

  const handleClear = () => {
    setUserName("");
    setUserId("");
    setUserNameToSearch("");
    setUserIdToSearch("");
    setPageToSearch(1);
  };

  const showClearButton = !!userId || !!userName;

  return (
    <Card cardTitle="Parents list">
      <FilterBar
        onSearch={handleSearch}
        onClear={handleClear}
        isLoading={isLoading}
        showClearButton={showClearButton}
      >
        {" "}
        <FilterInput
          label="User Id"
          placeholder="Search by parent id..."
          value={userId}
          onChange={(value) => setUserId(value as string)}
        />
        <FilterInput
          label="Parents name"
          placeholder="Search by parent name..."
          value={userName}
          onChange={(value) => setUserName(value as string)}
        />
      </FilterBar>

      <ListTable
        titles={parentsListTitle}
        data={data?.result}
        isDataLoading={isLoading}
        transformFn={transformParentsListTableData}
        pagination={{
          totalPage: data?.lastPage,
          onPageChange: (pageNo) => {
            setPageToSearch(pageNo);
          },
        }}
        onRowClick={(data: any) => {
          navigate(
            `${Paths.ParentsDetail}?section=${ParentNavigationHeader.PARENT_INFO}&parentId=${data.id}`,
          );
        }}
      />
    </Card>
  );
};
